import { Component, OnInit, inject } from '@angular/core';
import { PhoneList } from 'src/app/modules/user-profile/models/contact-oeds-person.model';
import { ContactVerificationService } from 'src/app/modules/user-profile/services/contact-verification-service';
import { ContactDataService } from 'src/app/modules/user-profile/services/contact-data-service';
import { ContactVerificationPhoneFormComponent } from '../contact-verification-phone-form/contact-verification-phone-form.component';
import { DeleteConfirmationComponent } from '../../../../../shared/components/delete-confirmation/delete-confirmation.component';
import { FormsModule } from '@angular/forms';
import { AlertComponent } from '../../../../../shared/components/alert/alert.component';


@Component({
    selector: 'app-contact-verification-phone',
    templateUrl: './contact-verification-phone.component.html',
    styleUrls: ['./contact-verification-phone.component.css'],
    imports: [AlertComponent, FormsModule, DeleteConfirmationComponent, ContactVerificationPhoneFormComponent]
})
export class ContactVerificationPhoneComponent implements OnInit {
  cservice = inject(ContactVerificationService);
  private cdataservice = inject(ContactDataService);


  showDelete = false;
  showPhoneForm = false;
  showAlert = false;

  phonelist: PhoneList[];

  homephonedtls: PhoneList;
  officephonedtls: PhoneList;
  mobilephonedtls: PhoneList;
  defaultPhone = {} as PhoneList;

  ngOnInit(): void {
    this.phonelist = this.cservice.oedsPersonCopy.phoneList;
    this.getAndAssignDefault();
    //this.resetOfficePhone();
  }
  addHyphen(number) {
    if (number != null) {
      return number.substring(0, 3) + "-" + number.substring(3, 7);
    }
    else {
      return number;
    }
  }
  resetOfficePhone() {
    if (!this.cservice.isUserOrgMappingExist) {
      this.confirmDelete(1,0);
    }
  }
 
  getAndAssignDefault() {
    this.homephonedtls = this.cservice.filterPhoneByType(2,this.phonelist)[0];
    if (!this.homephonedtls) {
      this.homephonedtls = {} as PhoneList;
      this.cservice.assignDefaultPhone(this.homephonedtls);
      this.homephonedtls.oedsPhoneType = 2;
      this.phonelist.push(this.homephonedtls);
    }

    this.officephonedtls = this.cservice.filterPhoneByType(1, this.phonelist)[0];
    if (!this.officephonedtls) {
      this.officephonedtls = {} as PhoneList;
      this.cservice.assignDefaultPhone(this.officephonedtls);
      this.officephonedtls.oedsPhoneType = 1;
      this.phonelist.push(this.officephonedtls);
    }
    if (this.officephonedtls.oedsPhoneKey !== 0) {
      this.cservice.hasOfficePhone = true;
    }

    this.mobilephonedtls = this.cservice.filterPhoneByType(3, this.phonelist)[0];
    if (!this.mobilephonedtls) {
      this.mobilephonedtls = {} as PhoneList;
      this.cservice.assignDefaultPhone(this.mobilephonedtls);
      this.mobilephonedtls.oedsPhoneType = 3;
      this.phonelist.push(this.mobilephonedtls);
    } 
  }
  //cservice.action = 'List';
  cancelUpdate() {
    if (this.cservice.selectedphone.primaryFlag) {
      this.phonelist.find(item => item.primaryFlag = false);
      this.phonelist.find(item => item.oedsPhoneType === this.cservice.selectedphone.oedsPhoneType).primaryFlag = true;
    }
    this.cservice.action = 'List';
    this.showDelete = true;
  }
  delete(number) {
    if (this.cservice.action === 'Delete' + number) {
      this.cservice.action = 'List';
      this.showDelete = true;
    } else {
      this.cservice.action = 'Delete' + number;
      this.showPhoneForm = false;
      this.showAlert = false;
    }
  }
  confirmDelete(phoneType, value: number) {
    this.cservice.deletePhoneByType(phoneType, this.phonelist);
    value = value + 1;
    this.delete(value);
  }
  phone(phoneType: PhoneList, number) {
    if (this.cservice.action === 'Phone' + number) {
      this.cservice.action = 'List';
      this.showDelete = true;
    } else {
      this.cservice.action = 'Phone' + number;
      this.showDelete = false;
      this.showAlert = false;
    }
    if (phoneType.oedsPhoneKey !== 0)
      phoneType.actionType = 'Updated'
    this.cservice.selectedphone = phoneType;
  }
  alert(number) {
    if (this.cservice.action === 'Alert' + number) {
      this.cservice.action = 'List';
      this.showAlert = true;
    } else {
      this.cservice.action = 'Alert' + number;
      this.showDelete = false;
      this.showPhoneForm = false;
    }
  }
  
  updatestepcount(isnext) {
    this.cservice.action = "";
    if (isnext) {
      this.cservice.setStep('Review and Submit')
      this.cservice.stepCount++;
    }
    else {
      this.cservice.isBackNav = true;
      this.cservice.setStep('Address')
      this.cservice.stepCount--;
    }
  }
  SetDefaultPrimaryFlag() {
    if (this.officephonedtls.areaCode !== null && this.cservice.isUserOrgMappingExist === true)
      this.officephonedtls.primaryFlag = true;
    else if (this.homephonedtls.areaCode !== null)
      this.homephonedtls.primaryFlag = true;
    else if (this.mobilephonedtls.areaCode !== null)
      this.mobilephonedtls.primaryFlag = true;
  }
  getIsFormvalid() {
    //If User Org Mapping exists then we should include office phone valdations
    //if (this.cservice.isUserOrgMappingExist === true) {
      //One phone number  should mandatory
      if ((this.officephonedtls.areaCode === null || this.officephonedtls.areaCode === "")
        && (this.homephonedtls.areaCode === null || this.homephonedtls.areaCode === "")
        && (this.mobilephonedtls.areaCode === null || this.mobilephonedtls.areaCode === ""))
        return true;
      //At least for one number primary flag should be enabled    
      else if ((this.officephonedtls.primaryFlag === false || this.officephonedtls.primaryFlag === null) && (this.homephonedtls.primaryFlag === false || this.homephonedtls.primaryFlag === null) && (this.mobilephonedtls.primaryFlag === false || this.mobilephonedtls.primaryFlag === null)) {
        this.SetDefaultPrimaryFlag();
        return false;
      }
      else if (
        (this.officephonedtls === undefined || this.officephonedtls.actionType === "Deleted" || ((this.officephonedtls.oedsPhoneKey === 0 && this.officephonedtls.isConfirm === false) || (this.officephonedtls.oedsPhoneKey !== 0 && (this.officephonedtls.isConfirm === true || this.officephonedtls.actionType === "Updated"))))
        &&
        (this.homephonedtls === undefined || this.homephonedtls.actionType === "Deleted" || ((this.homephonedtls.oedsPhoneKey === 0 && this.homephonedtls.isConfirm === false) || (this.homephonedtls.oedsPhoneKey !== 0 && (this.homephonedtls.isConfirm === true || this.homephonedtls.actionType === "Updated"))))
        &&
        (this.mobilephonedtls === undefined || this.mobilephonedtls.actionType === "Deleted" || ((this.mobilephonedtls.oedsPhoneKey === 0 && this.mobilephonedtls.isConfirm === false) || (this.mobilephonedtls.oedsPhoneKey !== 0 && (this.mobilephonedtls.isConfirm === true || this.mobilephonedtls.actionType === "Updated"))))
      )
        return false;
      else
        return true;
    //}
    //else {
    //  //One phone number  should mandatory
    //  if ((this.homephonedtls.areaCode === null || this.homephonedtls.areaCode === "")ss
    //    && (this.mobilephonedtls.areaCode === null || this.mobilephonedtls.areaCode === ""))
    //    return true;
    //  //At least for one number primary flag should be enabled    
    //  else if ((this.homephonedtls.primaryFlag === false || this.homephonedtls.primaryFlag === null) && (this.mobilephonedtls.primaryFlag === false || this.mobilephonedtls.primaryFlag === null)) {
    //    this.SetDefaultPrimaryFlag();
    //    return false;
    //  }
    //  else if (
    //    (this.homephonedtls === undefined || this.homephonedtls.actionType === "Deleted" || ((this.homephonedtls.oedsPhoneKey === 0 && this.homephonedtls.isConfirm === false) || (this.homephonedtls.oedsPhoneKey !== 0 && (this.homephonedtls.isConfirm === true || this.homephonedtls.actionType === "Updated"))))
    //    &&
    //    (this.mobilephonedtls === undefined || this.mobilephonedtls.actionType === "Deleted" || ((this.mobilephonedtls.oedsPhoneKey === 0 && this.mobilephonedtls.isConfirm === false) || (this.mobilephonedtls.oedsPhoneKey !== 0 && (this.mobilephonedtls.isConfirm === true || this.mobilephonedtls.actionType === "Updated"))))
    //  )
    //    return false;
    //  else
    //    return true;
    //}
  }
}
